module.exports = __webpack_public_path__ + "img/hr-fast-splitter-north.35e2d79d.png";